import { Application } from "@hotwired/stimulus"
import Notification from 'stimulus-notification'
import Reveal from 'stimulus-reveal-controller'

Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target)
}

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

// ViewComponents in app/views/components
const viewComponentControllers = import.meta.glob('./../../views/components/**/controller.js', { eager: true })

function convertFilenameToControllerName(filename) {
  return filename
    .replace(/^\.\//, "") // Remove ./ prefix
    .replace(/_controller.[j|t]s$/, "") // Strip _controller.js extension
    .replace(/\//g, "--") // Replace folders with -- namespaces
    .replace(/_/g, '-') //
}

//Vite
Object.entries(viewComponentControllers).forEach(([name, module]) => {
  // Tidy up controller name
  // ..--..--views--components--video-reviewer--controller.js => video-reviewer
  const controllerName = convertFilenameToControllerName(name)
    .replaceAll('..--..--views--components--', '')
    .replaceAll('--controller.js', '')
  
  application.register(controllerName, module.default)
})

// Register additional packages
application.register('notification', Notification)
application.register('reveal', Reveal)

export { application }
